import React from "react";
import {IonSpinner} from "@ionic/react";
import {IRouteProps} from "../../../ts/manager/view/ViewInterface";


const LoadingPartial = (props:IRouteProps) =>
{
    const content: React.JSX.Element = <>
        <div className="row">

            <div className="col-12 text-center">
                <IonSpinner></IonSpinner>
            </div>
        </div>
    </>

    return <>
        <section className="content-block">
            <div className="container">
                {content}
            </div>
        </section>
    </>;
}

export default LoadingPartial;